import Route from '@ember/routing/route';
import { service } from '@ember/service';
import CampaignModel from 'donor-elf-web/models/campaign';
import CampaignService from 'donor-elf-web/services/campaign-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface CampaignsCampaignRouteModel {
  campaign: CampaignModel;
}

export default class CampaignsCampaignRoute extends Route {
  @service declare campaignService: CampaignService;
  @service declare navbarSettings: NavbarSettingsService;

  model(params: { campaignId: string }): CampaignsCampaignRouteModel {
    let campaign = this.campaignService.campaigns.find(
      (c) => c.id === params.campaignId,
    )!;
    this.navbarSettings.title = `Campaign: ${campaign.label}`;
    return { campaign };
  }
}
